module.exports = __webpack_public_path__ + "img/2.e3ea993e.png";